module.exports = "<p>\n  employees-list works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/employees/employees-list/employees-list.component.html
// module id = ./src/app/employees/employees-list/employees-list.component.html
// module chunks = main